export const QpayTerminalPaymentResponseResults = {
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
} as const;

export type QpayTerminalPaymentResponseResult = (typeof QpayTerminalPaymentResponseResults)[keyof typeof QpayTerminalPaymentResponseResults];
